import { createSlice } from '@reduxjs/toolkit';

export interface GuestPassState {
  triggerUpdate: boolean;
}

const initialState: GuestPassState = {
  triggerUpdate: false,
};

const guestPassSlice = createSlice({
  name: 'guestPass',
  initialState,
  reducers: {
    triggerGuestPassUpdate(state) {
      return {
        ...state,
        triggerUpdate: !state.triggerUpdate,
      };
    },
    resetGuestPassUpdate(state) {
      return {
        ...state,
        triggerUpdate: false,
      };
    },
  },
});

export const { triggerGuestPassUpdate, resetGuestPassUpdate } =
  guestPassSlice.actions;
export default guestPassSlice.reducer;
